import { TrendingSearchesService } from '@/backend/market'
import { TrendingSearchRepository } from '../../domain/repositories/TrendingSearchRepository'
import { TrendingSearchModel } from '../models/TrendingSearchModel'
import type { TrendingSearchFilterEntity } from '../../domain/entities/TrendingSearchFilterEntity'
import { TrendingSearchFilterModel } from '../models/TrendingSearchFilterModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { CreateUpdateTrendingSearchEntity } from '../../domain/entities/CreateUpdateTrendingSearchEntity'
import { CreateUpdateTrendingSearchModel } from '../models/CreateUpdateTrendingSearchModel'
import { TrendingSearchMiniModel } from '../models/TrendingSearchMiniModel'

export class TrendingSearchRepositoryImpl implements TrendingSearchRepository {
  async getTrendingSearches(
    filter: TrendingSearchFilterEntity
  ): Promise<PaginateEntity<TrendingSearchMiniModel[]> | { error: true }> {
    try {
      const filterModel = new TrendingSearchFilterModel(filter)
      const response = await TrendingSearchesService.getTrendingSearchesAdmin(filterModel)
      const trendingSearchModels = response.items?.map((item) => new TrendingSearchMiniModel(item))
      const result = new PaginateEntity<TrendingSearchModel[]>(response, trendingSearchModels)

      return result
    } catch {
      return { error: true }
    }
  }
  async getTrendingSearch(id: number): Promise<TrendingSearchModel | { error: true }> {
    try {
      const response = await TrendingSearchesService.getTrendingSearchByIdAdmin({ id })
      const trendingSearchModel = new TrendingSearchModel(response)

      return trendingSearchModel
    } catch {
      return { error: true }
    }
  }
  async createTrendingSearch(
    data: CreateUpdateTrendingSearchEntity
  ): Promise<number | { error: true }> {
    try {
      const createUpdateTrendingSearchModel = new CreateUpdateTrendingSearchModel(data)
      const response = await TrendingSearchesService.createTrendingSearchAdmin({
        requestBody: createUpdateTrendingSearchModel
      })
      return response.id!
    } catch {
      return { error: true }
    }
  }
  async updateTrendingSearch(
    id: number,
    data: CreateUpdateTrendingSearchEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const createUpdateTrendingSearchModel = new CreateUpdateTrendingSearchModel(data)
      await TrendingSearchesService.updateTrendingSearchAdmin({
        id,
        requestBody: createUpdateTrendingSearchModel
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteTrendingSearch(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await TrendingSearchesService.deleteTrendingSearchAdmin({ id })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
